import "./index.moduleRenamed.css";

export const styleTitle = "index-module__styleTitle___Fq-99";
export const title = "index-module__title___ZWTAu";
export const conditionStyleCard = "index-module__conditionStyleCard___8IFPA";
export const condStyleTitle = "index-module__condStyleTitle___OQ0Ip";
export const condStyleItem = "index-module__condStyleItem___A02dG";
export const activedcondStyleItem = "index-module__activedcondStyleItem___qKxOs";
export const conditionStyleButton = "index-module__conditionStyleButton___AfsW6";
export const flexTitle = "index-module__flexTitle___UYCtv";
export const switchAndEditStyleButton = "index-module__switchAndEditStyleButton___v6PEn";
export const panelStateCssEditorList = "index-module__panelStateCssEditorList___gvjDu";
export const inlineSwitchSpan = "index-module__inlineSwitchSpan___4aLcl";
export const onlySelectedEditor = "index-module__onlySelectedEditor___jTD6V";
export const multiEditor = "index-module__multiEditor___Tb4nH";
export const readOnlyEditor = "index-module__readOnlyEditor___--SJw";
export const renameForm = "index-module__renameForm___XFVwK";
export const buttonGroup = "index-module__buttonGroup___4p-yu";

export default {
  styleTitle: "index-module__styleTitle___Fq-99",
  title: "index-module__title___ZWTAu",
  conditionStyleCard: "index-module__conditionStyleCard___8IFPA",
  condStyleTitle: "index-module__condStyleTitle___OQ0Ip",
  condStyleItem: "index-module__condStyleItem___A02dG",
  activedcondStyleItem: "index-module__activedcondStyleItem___qKxOs",
  conditionStyleButton: "index-module__conditionStyleButton___AfsW6",
  flexTitle: "index-module__flexTitle___UYCtv",
  switchAndEditStyleButton: "index-module__switchAndEditStyleButton___v6PEn",
  panelStateCssEditorList: "index-module__panelStateCssEditorList___gvjDu",
  inlineSwitchSpan: "index-module__inlineSwitchSpan___4aLcl",
  onlySelectedEditor: "index-module__onlySelectedEditor___jTD6V",
  multiEditor: "index-module__multiEditor___Tb4nH",
  readOnlyEditor: "index-module__readOnlyEditor___--SJw",
  renameForm: "index-module__renameForm___XFVwK",
  buttonGroup: "index-module__buttonGroup___4p-yu",
};